import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <footer>
        <div className="content">
          <div className="footer_content">
            <ul>
              <li>
                <span>Content copyright and images from www.udemy.com and itviec.com</span>
              </li>
              
              <li>
                <span>Name:  Sang Tran </span>
              </li>
              <li>
                <span>Mail: gnas93.ci@gmail.com</span>
              </li>
            </ul>
           
            {/* <select>
              <option>English</option>
              <option>Vietnamese</option>
            </select> */}
          </div>
          <div className="footer_content_2">
            <h4>I-Learning</h4>
            <p className="m-0">
              <i className="fa fa-copyright"></i>
              <span>I-Learning, Inc.</span>
            </p>
          </div>
        </div>
      </footer>
    );
  }
}
